export default "__VITE_ASSET__85cd24da__"